
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11450',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11450",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.200",
  "data-fetching-client": "static-1.9442",
  "foundations-components": "static-1.7456",
  "foundations-components-legacy": "static-1.481",
  "foundations-theming": "static-1.4174",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.76",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7771",
  "hub-http-shared-msw-handlers": "static-1.9392",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1560",
  "jasmine-runner": "static-1.6238",
  "marketplace-storefront-base": "static-1.11510",
  "quartz": "static-1.6681",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16406",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2629",
  "reporting-testing-lib": "static-1.8301",
  "settings-ui-lib": "static-1.12285",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6659",
  "ui-addon-i18n": "static-1.10897",
  "ui-addon-react-router-dom": "static-1.9314",
  "unified-auth": "static-1.157",
  "unified-auth-core-lib": "static-1.438",
  "usage-tracker": "static-1.7099",
  "usage-tracker-core": "static-1.6949",
  "customer-data-property-utils": "static-1.7837",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15301",
  "marketplace-ui-common": "static-1.18853",
  "property-management-iframe": "static-1.12174",
  "quartz-config": "static-1.459",
  "quartz-core": "static-1.5900",
  "quartz-routing": "static-1.111",
  "quick-fetch": "static-1.3701",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4397",
  "ts-schema": "static-1.3873",
  "ui-universal-auth": "static-1.8643",
  "UIComponents": "static-3.8134",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2958",
  "quartz-webpack": "static-1.2905",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3725",
  "floating-ui": "static-1.50",
  "foundations-assets": "static-1.4598",
  "foundations-theming-specialty": "static-1.1890",
  "framer-motion": "static-1.66",
  "hs-story-utils": "static-1.9194",
  "react-aria": "static-1.60",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5142",
  "react-virtualized": "static-2.93",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1095",
  "ui-fonts": "static-1.449",
  "ui-images": "static-2.1083",
  "bend-plugin-foundations-theming": "static-1.2657",
  "foundations-theming-base": "static-1.3159",
  "stylex": "static-1.26",
  "HeadJS": "static-2.702",
  "hs-test-utils-bend-plugin": "static-1.2882",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4095",
  "ai-components-ui-library": "static-1.8254",
  "ai-rendering-library": "static-1.9194",
  "chirp-fetch": "static-1.1649",
  "connections-embed-lib": "static-1.575",
  "copilot-toolkit": "static-1.10433",
  "laboratory-lib": "static-3.6928",
  "marketplace-embed": "static-1.21385",
  "marketplace-ui-details": "static-1.8749",
  "marketplace-ui-reviews": "static-1.18809",
  "marketplace-ui-tracking": "static-1.13024",
  "sanitize-text": "static-1.7905",
  "ui-addon-video-player": "static-1.8461",
  "usage-tracker-multi": "static-1.5513",
  "usage-tracker-session-replay": "static-1.4785",
  "wootric-nps": "static-1.6747",
  "apollo-link-hub-http": "static-2.4415",
  "immer": "static-1.33",
  "immerable": "static-1.3920",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2374",
  "reporting-data": "static-1.66368",
  "cssUtils": "static-1.722",
  "flux-actions": "static-1.303",
  "HubStyle": "static-2.11495",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9978",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10138",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7089",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17386",
  "storybook-react": "static-1.27",
  "trellis-story-utils": "static-1.4288",
  "foundations-components-test-utils": "static-1.4939",
  "quartz-i18n": "static-1.356",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3497",
  "customer-data-objects": "static-1.7410",
  "property-translator": "static-1.5179",
  "frontend-preferences-client": "static-1.7691",
  "hs-promise-utils": "static-1.5357",
  "hubspot-apollo-client": "static-1.4645",
  "integrations-error-boundary-lib": "static-1.12716",
  "integrations-tracking-lib": "static-1.5349",
  "native-integrations-shared-strings": "static-1.7554",
  "reselect": "static-2.16",
  "sanitize": "static-1.4240",
  "superstore": "static-1.4537",
  "ui-shepherd-react": "static-3.9910",
  "ai-settings-ui-library": "static-1.7334",
  "hub-http-janus": "static-1.785",
  "hubspotter-http": "static-1.4447",
  "immutable-less": "static-1.4419",
  "marketplace-ui-client-types": "static-1.16260",
  "nav-meta": "static-1.28789",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10002",
  "ui-addon-upgrades": "static-9.17598",
  "inbound-db-properties-service-client": "static-1.3645",
  "property-management-common": "static-1.4461",
  "ui-addon-iframeable": "static-1.8807",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.475",
  "quartz-auth": "static-1.356",
  "quartz-head": "static-1.346",
  "quartz-test": "static-1.356",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2899",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20171",
  "ContentUtils": "static-1.67518",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2251",
  "customer-data-filters-ui": "static-1.38757",
  "customer-data-objects-ui-components": "static-1.12769",
  "customer-data-reference-ui-components": "static-1.12907",
  "embedded-academy-lib": "static-1.13381",
  "ExportDialog": "static-6.10154",
  "highlight.js": "static-1.73",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40553",
  "reporting-snowflake": "static-1.54986",
  "reporting-ui-components": "static-2.63640",
  "reporting-visualizations": "static-1.58444",
  "ui-addon-teams": "static-1.21193",
  "magpie-lib": "static-1.5359",
  "magpie-types": "static-1.4819",
  "simple-logging-lib": "static-1.2816",
  "navigation-components": "static-1.17152",
  "ai-studio-lib": "static-1.10898",
  "developer-experience-shared-components": "static-1.10231",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7750",
  "ui-tool-access": "static-1.9909",
  "usage-based-billing-components-lib": "static-1.7920",
  "usage-tracker-anonymous": "static-1.5516",
  "usage-tracker-public": "static-1.6910",
  "amplitude-session-replay-browser": "static-1.54",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3473",
  "reference-resolvers": "static-1.7925",
  "ui-extensibility-client-types": "static-1.3715",
  "hubspot-apollo-cache": "static-1.104",
  "universal-page-editor-lib": "static-1.2763",
  "redux-toolkit": "static-1.7",
  "merchandise-lib": "static-1.257",
  "atom": "static-1.4836",
  "purchase-motions-components": "static-1.5435",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4273",
  "batch-promise": "static-1.1316",
  "crm-component-utils": "static-1.38396",
  "crm-properties-common-lib": "static-1.5636",
  "framework-data-schema-resolvers": "static-1.6635",
  "reference-resolvers-lite": "static-1.7855",
  "navigation-messaging": "static-1.6479",
  "hubspotter-http-shared-msw-handlers": "static-1.9390",
  "cms-field-types": "static-1.4572",
  "content-icons-ui": "static-1.2143",
  "conversations-skeleton-state": "static-1.7015",
  "crm-message-bus": "static-1.42243",
  "customer-data-filters-ui-msw-helpers": "static-1.21191",
  "customer-data-ui-utilities": "static-1.9590",
  "FormUrlGenerator": "static-2.4496",
  "framework-builder-read-service-client": "static-1.3815",
  "framework-data-schema-quick-fetch": "static-1.6540",
  "multi-account-reference-resolvers": "static-1.733",
  "onboarding-tours": "static-1.16211",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12952",
  "academy-common-lib": "static-1.12841",
  "content-assistance-lib": "static-1.7397",
  "dashboard-lib": "static-1.80466",
  "file-manager-components": "static-1.22784",
  "getting-started-shared-tasks": "static-1.17780",
  "hubspot-prosemirror": "static-1.17504",
  "hubspot-prosemirror-plugins": "static-1.17496",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19415",
  "share-with-third-party-component-lib": "static-1.8456",
  "ui-addon-draggable": "static-3.4531",
  "ui-asset-management-lib": "static-1.10663",
  "ui-business-units-lib": "static-1.8788",
  "user-context": "static-1.4860",
  "growth-payments-core": "static-1.24625",
  "highcharts": "static-8.98",
  "reporting-plugins": "static-1.9937",
  "reporting-reports": "static-1.66046",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.492",
  "codemirror": "static-5.89",
  "feedback-loader": "static-1.28788",
  "react-codemirror": "static-1.10392",
  "apps-service-types": "static-1.3643",
  "oauth-service-types": "static-1.4006",
  "onboarding-scopes": "static-1.6230",
  "onboarding-tours-client": "static-1.4425",
  "platform-infra-nav-components": "static-1.7462",
  "subscription-experience-data-types": "static-1.14540",
  "crm-record-cards-service-types": "static-1.3421",
  "location-customization-utils-lib": "static-1.8445",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4289",
  "nav-client-types": "static-1.2121",
  "purchase-motions-api": "static-1.5438",
  "signup-constants": "static-1.18319",
  "signup-ui-url-generator": "static-2.7829",
  "trials-service-types": "static-1.3690",
  "card-properties-lib": "static-1.43422",
  "crm-actions": "static-1.6060",
  "crm-cards-data": "static-1.1139",
  "crm-cards-sdk": "static-1.42806",
  "customer-data-properties": "static-1.50684",
  "customer-data-properties-shared-msw-handlers": "static-1.8719",
  "customer-data-tracking": "static-1.6648",
  "conditional-properties-service-client": "static-1.3593",
  "crm-pipelines-api-client-types": "static-1.3934",
  "multi-currency-client-types": "static-1.3487",
  "external-options-client-types": "static-1.3953",
  "react-dnd-compat": "static-1.4389",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2836",
  "growth-onboarding-next-action-utils": "static-1.1260",
  "onboarding-tours-utils": "static-1.277",
  "ui-shepherd-tracker": "static-1.7291",
  "academy-service-client": "static-1.3446",
  "final-form": "static-1.64",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27849",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8152",
  "video-components-external": "static-1.10472",
  "video-data-lib": "static-1.34130",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8334",
  "payment-link-components": "static-1.22835",
  "ui-addon-emoji-picker": "static-1.9655",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6794",
  "data-token-picker": "static-1.15988",
  "FileManagerLib": "static-1.38424",
  "react-flip-move": "static-1.64",
  "timezone-utils": "static-2.5010",
  "getting-started-shared-tasks-store": "static-1.16898",
  "campaign-roi-lib": "static-1.8182",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.156",
  "eligibility-engine-service-types": "static-1.2971",
  "crm_data": "static-4.91100",
  "crm-links": "static-1.6020",
  "customer-data-sidebar": "static-2.45318",
  "enrichment-properties-lib": "static-1.14869",
  "crm-fe-perf": "static-1.22673",
  "calling-global-api": "static-1.63534",
  "calling-internal-common": "static-1.31057",
  "calling-lifecycle-internal": "static-1.64916",
  "calling-lifecycle-messages": "static-1.57210",
  "commerce-products-lib": "static-1.8749",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.437",
  "inbounddb-objects-service-types": "static-1.4019",
  "meetings-icalendar-utils-lib": "static-1.400",
  "object-builder-ui-client": "static-1.47851",
  "pipeline-validation-client-types": "static-1.3756",
  "property-value-citations": "static-1.1298",
  "pulse": "static-1.268",
  "smart-property-lib": "static-1.5751",
  "tiered-pricing": "static-1.778",
  "ui-addon-form-validation": "static-1.10759",
  "growth-onboarding-feedback-components": "static-1.6351",
  "content-media-composition-data-lib": "static-1.11327",
  "content-media-compositions": "static-2.15334",
  "media-bridge-lib": "static-1.18510",
  "commerce-tours-lib": "static-1.5666",
  "growth-onboarding-reliability": "static-1.4854",
  "sales-checkout-service-client": "static-1.3443",
  "draft-convert": "static-2.66",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.71",
  "draft-plugins": "static-2.21253",
  "sales-email-signature-service-client": "static-1.3610",
  "audio-components": "static-1.5562",
  "FileManagerCore": "static-1.38283",
  "FileManagerImages": "static-1.35935",
  "video-components": "static-1.12475",
  "crm_universal": "static-1.21605",
  "customer-data-email": "static-1.17612",
  "calling-error-reporting": "static-1.31063",
  "card-payment-highlight-lib": "static-1.36404",
  "card-subscription-highlight-lib": "static-1.38760",
  "commerce-billing-lib": "static-1.18398",
  "commerce-contract-lib": "static-1.11030",
  "customer-data-content": "static-1.26815",
  "invoices-highlight-card-lib": "static-1.53889",
  "orders-highlight-card-lib": "static-1.20786",
  "products-highlight-card-lib": "static-1.17033",
  "project-storage": "static-1.4498",
  "quotes-highlight-card-lib": "static-1.71025",
  "breeze-intelligence-kit": "static-1.5270",
  "crm-source-interpretation-lib": "static-1.5097",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9475",
  "policy-lib": "static-1.6550",
  "shared-worker-versioning": "static-1.10803",
  "calling-usage-tracker": "static-1.6304",
  "voice-sms-access-library": "static-1.136",
  "products-iframe-lib": "static-1.7220",
  "products-ui-components-shared-msw-handlers": "static-1.9774",
  "directed-graph": "static-1.703",
  "event-emitter": "static-1.713",
  "react-tinymce": "static-1.54526",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9538",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53652",
  "tinymce-plugins": "static-1.56766",
  "tinymce-themes": "static-1.55622",
  "hls.js": "static-1.33",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4299",
  "video-embed": "static-1.34964",
  "social-insights-client-types": "static-1.21255",
  "sequences-lib": "static-1.7635",
  "ui-gdpr-components": "static-1.10112",
  "commerce-shared-components-lib": "static-1.17827",
  "commerce-subscription-lib": "static-1.36337",
  "commerce-tools-ui-lib": "static-1.9705",
  "utility-belt": "static-1.2308",
  "payments-enrollment-embed-lib": "static-1.21853",
  "products-ui-components": "static-1.39268",
  "quotes-client-types": "static-1.37113",
  "quotes-ui-lib": "static-1.79744",
  "SalesContentIndexUI": "static-3.8850",
  "accounting-integrations-ui-components": "static-1.6673",
  "invoices-ui-lib": "static-1.53905",
  "commerce-products-api": "static-1.1906",
  "SafeStorage": "static-1.4170",
  "invoices-iframe-lib": "static-1.55963",
  "quotes-modal-lib": "static-1.101701",
  "calling-orchestration-schema": "static-1.34913",
  "sales-views-client-types": "static-1.4057",
  "hub-http-contrib": "static-1.2810",
  "interframe": "static-3.4557",
  "tinymce-data": "static-1.39737",
  "ui-addon-sales-email": "static-1.4979",
  "layout-dnd-components": "static-1.11971",
  "layout-dnd-utils": "static-1.10946",
  "ui-brand-identity-lib": "static-1.13694",
  "NamespacedHubStyle": "static-2.8866",
  "outpost": "static-1.3973",
  "sequences-client-types-lib": "static-1.7492",
  "customer-data-associations": "static-1.7102",
  "framework-data-table": "static-2.11334",
  "customer-data-rte": "static-1.32362",
  "cv-backend-services": "static-1.1486",
  "growth-onboarding-empty-states": "static-1.5312",
  "InboxConnectUtils": "static-4.14132",
  "payments-post-enroll-local-storage-lib": "static-1.4878",
  "qrcode-generator": "static-1.63",
  "stripe-embedded-components": "static-1.7077",
  "commerce-permissions": "static-1.518",
  "commerce-tax-lib": "static-1.271",
  "property-description-translator": "static-1.3625",
  "FireAlarmUi": "static-1.4296",
  "sales-templates-service-types-lib": "static-1.3962",
  "commerce-analytics-service-client": "static-1.3431",
  "totals-ui-components": "static-1.22911",
  "ContentData": "static-1.67593",
  "layout-data-lib": "static-1.9271",
  "deal-intel-decorators": "static-1.1119",
  "tanstack-virtual": "static-1.24",
  "draft-content-plugins": "static-1.27630",
  "stripe-connect-js": "static-1.63",
  "commerce-totals-service-types": "static-1.3607",
  "advanced-menus-core": "static-1.14766",
  "advanced-menus-lib": "static-1.11748",
  "ui-memberships-settings-lib": "static-1.33333",
  "deal-intel-utils": "static-1.1123",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14765",
  "simple-menus-lib": "static-1.16282"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11450",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.200",
  "data-fetching-client": "/data-fetching-client/static-1.9442",
  "foundations-components": "/foundations-components/static-1.7456",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.481",
  "foundations-theming": "/foundations-theming/static-1.4174",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.76",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7771",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9392",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1560",
  "jasmine-runner": "/jasmine-runner/static-1.6238",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11510",
  "quartz": "/quartz/static-1.6681",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16406",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2629",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8301",
  "settings-ui-lib": "/settings-ui-lib/static-1.12285",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6659",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10897",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9314",
  "unified-auth": "/unified-auth/static-1.157",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.438",
  "usage-tracker": "/usage-tracker/static-1.7099",
  "usage-tracker-core": "/usage-tracker-core/static-1.6949",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7837",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15301",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18853",
  "property-management-iframe": "/property-management-iframe/static-1.12174",
  "quartz-config": "/quartz-config/static-1.459",
  "quartz-core": "/quartz-core/static-1.5900",
  "quartz-routing": "/quartz-routing/static-1.111",
  "quick-fetch": "/quick-fetch/static-1.3701",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4397",
  "ts-schema": "/ts-schema/static-1.3873",
  "ui-universal-auth": "/ui-universal-auth/static-1.8643",
  "UIComponents": "/UIComponents/static-3.8134",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2958",
  "quartz-webpack": "/quartz-webpack/static-1.2905",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3725",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-assets": "/foundations-assets/static-1.4598",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1890",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9194",
  "react-aria": "/react-aria/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5142",
  "react-virtualized": "/react-virtualized/static-2.93",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1095",
  "ui-fonts": "/ui-fonts/static-1.449",
  "ui-images": "/ui-images/static-2.1083",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2657",
  "foundations-theming-base": "/foundations-theming-base/static-1.3159",
  "stylex": "/stylex/static-1.26",
  "HeadJS": "/HeadJS/static-2.702",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2882",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4095",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8254",
  "ai-rendering-library": "/ai-rendering-library/static-1.9194",
  "chirp-fetch": "/chirp-fetch/static-1.1649",
  "connections-embed-lib": "/connections-embed-lib/static-1.575",
  "copilot-toolkit": "/copilot-toolkit/static-1.10433",
  "laboratory-lib": "/laboratory-lib/static-3.6928",
  "marketplace-embed": "/marketplace-embed/static-1.21385",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8749",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18809",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13024",
  "sanitize-text": "/sanitize-text/static-1.7905",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8461",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5513",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4785",
  "wootric-nps": "/wootric-nps/static-1.6747",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4415",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3920",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2374",
  "reporting-data": "/reporting-data/static-1.66368",
  "cssUtils": "/cssUtils/static-1.722",
  "flux-actions": "/flux-actions/static-1.303",
  "HubStyle": "/HubStyle/static-2.11495",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9978",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10138",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7089",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17386",
  "storybook-react": "/storybook-react/static-1.27",
  "trellis-story-utils": "/trellis-story-utils/static-1.4288",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4939",
  "quartz-i18n": "/quartz-i18n/static-1.356",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3497",
  "customer-data-objects": "/customer-data-objects/static-1.7410",
  "property-translator": "/property-translator/static-1.5179",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "hs-promise-utils": "/hs-promise-utils/static-1.5357",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4645",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12716",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5349",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7554",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4240",
  "superstore": "/superstore/static-1.4537",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9910",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7334",
  "hub-http-janus": "/hub-http-janus/static-1.785",
  "hubspotter-http": "/hubspotter-http/static-1.4447",
  "immutable-less": "/immutable-less/static-1.4419",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16260",
  "nav-meta": "/nav-meta/static-1.28789",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10002",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17598",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3645",
  "property-management-common": "/property-management-common/static-1.4461",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8807",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.475",
  "quartz-auth": "/quartz-auth/static-1.356",
  "quartz-head": "/quartz-head/static-1.346",
  "quartz-test": "/quartz-test/static-1.356",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2899",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20171",
  "ContentUtils": "/ContentUtils/static-1.67518",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2251",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38757",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12769",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12907",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13381",
  "ExportDialog": "/ExportDialog/static-6.10154",
  "highlight.js": "/highlight.js/static-1.73",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40553",
  "reporting-snowflake": "/reporting-snowflake/static-1.54986",
  "reporting-ui-components": "/reporting-ui-components/static-2.63640",
  "reporting-visualizations": "/reporting-visualizations/static-1.58444",
  "ui-addon-teams": "/ui-addon-teams/static-1.21193",
  "magpie-lib": "/magpie-lib/static-1.5359",
  "magpie-types": "/magpie-types/static-1.4819",
  "simple-logging-lib": "/simple-logging-lib/static-1.2816",
  "navigation-components": "/navigation-components/static-1.17152",
  "ai-studio-lib": "/ai-studio-lib/static-1.10898",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10231",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7750",
  "ui-tool-access": "/ui-tool-access/static-1.9909",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7920",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5516",
  "usage-tracker-public": "/usage-tracker-public/static-1.6910",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3473",
  "reference-resolvers": "/reference-resolvers/static-1.7925",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3715",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.104",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "atom": "/atom/static-1.4836",
  "purchase-motions-components": "/purchase-motions-components/static-1.5435",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4273",
  "batch-promise": "/batch-promise/static-1.1316",
  "crm-component-utils": "/crm-component-utils/static-1.38396",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5636",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6635",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7855",
  "navigation-messaging": "/navigation-messaging/static-1.6479",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9390",
  "cms-field-types": "/cms-field-types/static-1.4572",
  "content-icons-ui": "/content-icons-ui/static-1.2143",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7015",
  "crm-message-bus": "/crm-message-bus/static-1.42243",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21191",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9590",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4496",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3815",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6540",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.733",
  "onboarding-tours": "/onboarding-tours/static-1.16211",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12952",
  "academy-common-lib": "/academy-common-lib/static-1.12841",
  "content-assistance-lib": "/content-assistance-lib/static-1.7397",
  "dashboard-lib": "/dashboard-lib/static-1.80466",
  "file-manager-components": "/file-manager-components/static-1.22784",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17780",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17504",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17496",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19415",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8456",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4531",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10663",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8788",
  "user-context": "/user-context/static-1.4860",
  "growth-payments-core": "/growth-payments-core/static-1.24625",
  "highcharts": "/highcharts/static-8.98",
  "reporting-plugins": "/reporting-plugins/static-1.9937",
  "reporting-reports": "/reporting-reports/static-1.66046",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.492",
  "codemirror": "/codemirror/static-5.89",
  "feedback-loader": "/feedback-loader/static-1.28788",
  "react-codemirror": "/react-codemirror/static-1.10392",
  "apps-service-types": "/apps-service-types/static-1.3643",
  "oauth-service-types": "/oauth-service-types/static-1.4006",
  "onboarding-scopes": "/onboarding-scopes/static-1.6230",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4425",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7462",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14540",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3421",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8445",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4289",
  "nav-client-types": "/nav-client-types/static-1.2121",
  "purchase-motions-api": "/purchase-motions-api/static-1.5438",
  "signup-constants": "/signup-constants/static-1.18319",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7829",
  "trials-service-types": "/trials-service-types/static-1.3690",
  "card-properties-lib": "/card-properties-lib/static-1.43422",
  "crm-actions": "/crm-actions/static-1.6060",
  "crm-cards-data": "/crm-cards-data/static-1.1139",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42806",
  "customer-data-properties": "/customer-data-properties/static-1.50684",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8719",
  "customer-data-tracking": "/customer-data-tracking/static-1.6648",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3593",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3934",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3487",
  "external-options-client-types": "/external-options-client-types/static-1.3953",
  "react-dnd-compat": "/react-dnd-compat/static-1.4389",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2836",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1260",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.277",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7291",
  "academy-service-client": "/academy-service-client/static-1.3446",
  "final-form": "/final-form/static-1.64",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27849",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8152",
  "video-components-external": "/video-components-external/static-1.10472",
  "video-data-lib": "/video-data-lib/static-1.34130",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8334",
  "payment-link-components": "/payment-link-components/static-1.22835",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9655",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6794",
  "data-token-picker": "/data-token-picker/static-1.15988",
  "FileManagerLib": "/FileManagerLib/static-1.38424",
  "react-flip-move": "/react-flip-move/static-1.64",
  "timezone-utils": "/timezone-utils/static-2.5010",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16898",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.156",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2971",
  "crm_data": "/crm_data/static-4.91100",
  "crm-links": "/crm-links/static-1.6020",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45318",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14869",
  "crm-fe-perf": "/crm-fe-perf/static-1.22673",
  "calling-global-api": "/calling-global-api/static-1.63534",
  "calling-internal-common": "/calling-internal-common/static-1.31057",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64916",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57210",
  "commerce-products-lib": "/commerce-products-lib/static-1.8749",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.437",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4019",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.400",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47851",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3756",
  "property-value-citations": "/property-value-citations/static-1.1298",
  "pulse": "/pulse/static-1.268",
  "smart-property-lib": "/smart-property-lib/static-1.5751",
  "tiered-pricing": "/tiered-pricing/static-1.778",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10759",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6351",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11327",
  "content-media-compositions": "/content-media-compositions/static-2.15334",
  "media-bridge-lib": "/media-bridge-lib/static-1.18510",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5666",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4854",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3443",
  "draft-convert": "/draft-convert/static-2.66",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.71",
  "draft-plugins": "/draft-plugins/static-2.21253",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3610",
  "audio-components": "/audio-components/static-1.5562",
  "FileManagerCore": "/FileManagerCore/static-1.38283",
  "FileManagerImages": "/FileManagerImages/static-1.35935",
  "video-components": "/video-components/static-1.12475",
  "crm_universal": "/crm_universal/static-1.21605",
  "customer-data-email": "/customer-data-email/static-1.17612",
  "calling-error-reporting": "/calling-error-reporting/static-1.31063",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36404",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38760",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18398",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11030",
  "customer-data-content": "/customer-data-content/static-1.26815",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53889",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20786",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17033",
  "project-storage": "/project-storage/static-1.4498",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71025",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5270",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5097",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9475",
  "policy-lib": "/policy-lib/static-1.6550",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10803",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6304",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.136",
  "products-iframe-lib": "/products-iframe-lib/static-1.7220",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9774",
  "directed-graph": "/directed-graph/static-1.703",
  "event-emitter": "/event-emitter/static-1.713",
  "react-tinymce": "/react-tinymce/static-1.54526",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9538",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53652",
  "tinymce-plugins": "/tinymce-plugins/static-1.56766",
  "tinymce-themes": "/tinymce-themes/static-1.55622",
  "hls.js": "/hls.js/static-1.33",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4299",
  "video-embed": "/video-embed/static-1.34964",
  "social-insights-client-types": "/social-insights-client-types/static-1.21255",
  "sequences-lib": "/sequences-lib/static-1.7635",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10112",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17827",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36337",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9705",
  "utility-belt": "/utility-belt/static-1.2308",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21853",
  "products-ui-components": "/products-ui-components/static-1.39268",
  "quotes-client-types": "/quotes-client-types/static-1.37113",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79744",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8850",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6673",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53905",
  "commerce-products-api": "/commerce-products-api/static-1.1906",
  "SafeStorage": "/SafeStorage/static-1.4170",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55963",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101701",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34913",
  "sales-views-client-types": "/sales-views-client-types/static-1.4057",
  "hub-http-contrib": "/hub-http-contrib/static-1.2810",
  "interframe": "/interframe/static-3.4557",
  "tinymce-data": "/tinymce-data/static-1.39737",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4979",
  "layout-dnd-components": "/layout-dnd-components/static-1.11971",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10946",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13694",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8866",
  "outpost": "/outpost/static-1.3973",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7492",
  "customer-data-associations": "/customer-data-associations/static-1.7102",
  "framework-data-table": "/framework-data-table/static-2.11334",
  "customer-data-rte": "/customer-data-rte/static-1.32362",
  "cv-backend-services": "/cv-backend-services/static-1.1486",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5312",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14132",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4878",
  "qrcode-generator": "/qrcode-generator/static-1.63",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7077",
  "commerce-permissions": "/commerce-permissions/static-1.518",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.271",
  "property-description-translator": "/property-description-translator/static-1.3625",
  "FireAlarmUi": "/FireAlarmUi/static-1.4296",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3962",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3431",
  "totals-ui-components": "/totals-ui-components/static-1.22911",
  "ContentData": "/ContentData/static-1.67593",
  "layout-data-lib": "/layout-data-lib/static-1.9271",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1119",
  "tanstack-virtual": "/tanstack-virtual/static-1.24",
  "draft-content-plugins": "/draft-content-plugins/static-1.27630",
  "stripe-connect-js": "/stripe-connect-js/static-1.63",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3607",
  "advanced-menus-core": "/advanced-menus-core/static-1.14766",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11748",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33333",
  "deal-intel-utils": "/deal-intel-utils/static-1.1123",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14765",
  "simple-menus-lib": "/simple-menus-lib/static-1.16282"
}
};
